module.exports = __webpack_public_path__ + "media/images/icon-more-off@3x-c845f6e19da65be58ac61acce86ee725.png";